<template minapp="mpx" xlang="wxml">
  <tab-bar checkTabIndex="{{checkTabIndex}}">
    <view slot="tab_buy">
      <ticket-bar />
    </view>
    <view slot="tab_cross">
      <crossPort-tab />
    </view>
    <view slot="tab_refund">
      <refund-tab />
    </view>
    <view slot="tab_change">
      <rebook-tab />
    </view>
    <view slot="tab_scramble">
      <scramble-tab />
    </view>
    <view slot="tab_student">
      <student-tab />
    </view>
    <view slot="tab_child">
      <children-tab />
    </view>
  </tab-bar>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'

  createPage({
    data: {
      // buy 购票取票
      // refund 退票
      // change 改签
      // student 学生票
      // child 儿童票
      // cross 广深港跨境列车
      checkTabIndex: 'buy'
    },
    mounted() {},
    onLoad() {
      const tabs = ['buy', 'refund', 'change', 'scramble', 'student', 'child', 'cross']
      const { checkTabIndex } = this.$mpxRoute.query
      this.checkTabIndex = tabs.includes(checkTabIndex) ? checkTabIndex : 'buy'
    }
  })
</script>

<style scoped lang="stylus"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'tab-bar': './components/tab-bar',
      'ticket-bar': './components/ticket-bar',
      'refund-tab': './components/refund-tab',
      'rebook-tab': './components/rebook-tab',
      'scramble-tab': './components/scramble-tab',
      'student-tab': './components/student-tab',
      'children-tab': './components/children-tab',
      'crossPort-tab': './components/crossPort-tab'
    }
  }
</script>